<template>
  <div class="ball-display__balls">
    <div v-for="(n, i) in mainNumbers" :key="'m-' + i" class="ball-col">
      <div class="ball" :class="ballColorClass(i)">
        <span class="ball-num">{{ slotIsDrawing(i) ? drawingChars[i] : n.value }}</span>
      </div>
      <span v-if="!drawPhaseNear && !slotIsDrawing(i)" class="ball-zodiac">{{ zodiacText(n) }}</span>
    </div>
    <div class="ball-col ball-col--plus"><span>+</span></div>
    <div class="ball-col">
      <div class="ball" :class="ballColorClass(6)">
        <span class="ball-num">{{ slotIsDrawing(6) ? drawingChars[6] : special.value }}</span>
      </div>
      <span v-if="!drawPhaseNear && !slotIsDrawing(6)" class="ball-zodiac">{{ zodiacText(special) }}</span>
    </div>
  </div>
</template>

<script>
const NUMBER_ELEMENT = {
  '金': [4, 5, 12, 13, 26, 27, 34, 35, 42, 43],
  '木': [8, 9, 16, 17, 24, 25, 38, 39, 46, 47],
  '水': [1, 14, 15, 22, 23, 30, 31, 44, 45],
  '火': [2, 3, 10, 11, 18, 19, 32, 33, 40, 41, 48, 49],
  '土': [6, 7, 20, 21, 28, 29, 36, 37]
}

export default {
  name: 'BallDisplay',
  props: {
    mainNumbers: { type: Array, required: true },
    special: { type: Object, required: true },
    drawPhaseNear: { type: Boolean, default: false },
    pollSlotRevealed: { type: Array, default: null },
    drawRevealed: { type: Array, default: null },
    isLiveDrawing: { type: Boolean, default: false },
    drawingChars: { type: Array, default: () => ['正','在','进','行','开','奖','中'] },
    ballTone: { type: Function, required: true }
  },
  methods: {
    elementOf(value) {
      const n = Number(value)
      if (!Number.isFinite(n)) return ''
      for (const el in NUMBER_ELEMENT) {
        if (NUMBER_ELEMENT[el].includes(n)) return el
      }
      return ''
    },
    zodiacText(ball) {
      if (!ball) return ''
      const z = ball.zodiac || ''
      const el = this.elementOf(ball.value)
      return el ? `${z}/${el}` : z
    },
    slotIsDrawing(index) {
      if (this.drawPhaseNear) return true
      if (this.pollSlotRevealed != null && this.pollSlotRevealed[index] !== true) return true
      if (this.drawRevealed != null && this.drawRevealed[index] !== true) return true
      const ball = index < 6 ? this.mainNumbers[index] : this.special
      if (!ball || !ball.value) return true
      return false
    },
    ballColorClass(index) {
      if (this.slotIsDrawing(index)) return 'ball--drawing'
      const ball = index < 6 ? this.mainNumbers[index] : this.special
      return 'ball--' + this.ballTone(ball)
    }
  }
}
</script>

<style scoped>
.ball-display__balls {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 0.15rem;
  flex: 1; min-width: 0; width: 100%;
}
.ball-col {
  flex: 0 0 auto; min-width: 0;
  display: flex; flex-direction: column; align-items: center; gap: 0.2rem;
}
.ball-col--plus {
  justify-content: center;
  padding-top: 0.3rem;
  font-size: 1.2rem;
}
.ball-col--plus span {
  font-weight: 800;
  color: #000000;
  font-size: clamp(2rem, 3.5vw, 1.5rem);
}
.ball {
  box-sizing: border-box;
  width: clamp(2.2rem, 10.5vw, 2.65rem);
  height: clamp(2.2rem, 10.5vw, 2.65rem);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16);
}
.ball--red   { background-image: url('~@/images/red.png'); }
.ball--blue  { background-image: url('~@/images/bule.png'); }
.ball--green { background-image: url('~@/images/green.png'); }
.ball--drawing { background-image: url('~@/images/gray.png'); }
.ball-num {
  display: inline-block;
  font-size: clamp(1rem, 4.8vw, 1.2rem);
  font-weight: 800; color: #0d0d0d; line-height: 1;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);
  transform: translate(clamp(-0.06rem, -0.35vw, -0.03rem), clamp(-0.1rem, -0.45vw, -0.06rem));
}
.ball--drawing .ball-num {
  font-size: clamp(1.15rem, 5.4vw, 1.4rem);
  transform: none;
}
.ball-zodiac {
  font-size: 0.8rem;
  font-weight: 600; color: #2d3748;
  white-space: nowrap;
}
</style>
